// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 用户登录 用户使用邮箱和密码进行登录，获取访问令牌。 POST /login */
export async function doLogin(
  body: API.LoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.ResultLoginResponse>(`/api/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户登出 使当前用户的访问令牌失效。 GET /logout */
export async function doLogout(options?: { [key: string]: any }) {
  return request<API.ResultBoolean>(`/api/logout`, {
    method: "GET",
    ...(options || {}),
  });
}

/** 用户注册 新用户使用邮箱和验证码进行注册。 POST /register */
export async function doRegister(
  body: API.RegisterRequest,
  options?: { [key: string]: any }
) {
  return request<API.ResultString>(`/api/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 注册时发送邮箱验证码 向指定邮箱发送注册验证码。 POST /register/email/verifyCode */
export async function doRegisterVerifyCode(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.doRegisterVerifyCodeParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultString>(`/api/register/email/verifyCode`, {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 重置密码时发送邮箱验证码 向指定邮箱发送重置密码验证码。 POST /reset/email/verifyCode */
export async function doResetPasswordVerifyCode(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.doResetPasswordVerifyCodeParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultString>(`/api/reset/email/verifyCode`, {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 重置密码 使用邮箱验证码重置用户密码。 POST /resetPassword */
export async function doResetPassword(
  body: API.ResetPasswordRequest,
  options?: { [key: string]: any }
) {
  return request<API.ResultString>(`/api/resetPassword`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前用户信息 获取当前登录用户的详细信息。 GET /user */
export async function getUserInfo(options?: { [key: string]: any }) {
  return request<API.ResultSysUser>(`/api/user`, {
    method: "GET",
    ...(options || {}),
  });
}

/** 更新当前用户昵称 修改当前登录用户的昵称。 POST /user/current/nickName */
export async function updateCurrentNickName(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateCurrentNickNameParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultString>(`/api/user/current/nickName`, {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
